module.exports = __webpack_public_path__ + "static/main-graphic@2x-5fc986b1c7d8c3e3bcef207e6128da35.png";